import { resolveOriginalBriefUrl } from "@/features/opportunities/lib/original-brief-url";

export type CustomAssetKind = "SCRIPT" | "BRIEF";

export function isCustomAssetScript(script: {
  customAssetUploadId?: string | null;
  originalBriefUrl?: string | null;
  rationale?: string | null;
}): boolean {
  if (script.customAssetUploadId?.trim()) return true;
  return Boolean(resolveOriginalBriefUrl(script));
}

export function isImportedBriefScript(script: {
  customAssetKind?: CustomAssetKind | null;
}): boolean {
  return script.customAssetKind === "BRIEF";
}

export function customAssetKindLabel(
  kind: CustomAssetKind | null | undefined,
  t: (key: string, fallback: string) => string,
): string {
  if (kind === "BRIEF") {
    return t("marketplace.customBrief.kindBrief", "Brief");
  }
  return t("marketplace.customBrief.kindScript", "Script");
}
